var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 138,
    viewBox: "0 0 280 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 138L0 138C69.882 122.362 73.2743 110.272 112.378 100.124C257.808 62.3816 259.225 100.94 280 114.405L280 138Z",
    fill: "#004484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228 13.4308C228 -3.88043 262.667 -0.831293 280 2.85719V83.266C280 67.2826 228 35.0699 228 13.4308Z",
    fill: "#0071DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerRight);
export default __webpack_public_path__ + "static/media/BannerRight.88fdfcea8eef384a643522ec46cbf90e.svg";
export { ForwardRef as ReactComponent };